import { Brand } from 'client/context/config';
import React from 'react';

const GlobalThemeComponent =
  process.env.NODE_ENV === 'production'
    ? null
    : React.lazy(() =>
        import('@tvg/fuse-design/themes').then((m) => ({
          default: m.GlobalThemeComponent,
        })),
      );

export default function GlobalTheme({ brand }: { brand: Brand | undefined }) {
  if (!GlobalThemeComponent || typeof window === 'undefined') return null;

  const fuseBrand = brand === 'veryireland' ? 'very' : brand;
  return (
    <React.Suspense fallback={null}>
      <GlobalThemeComponent brand={fuseBrand} renderGlobalResetStyles={false} />
    </React.Suspense>
  );
}
